import React from "react";
import styled from "styled-components";

const AlertComponent = ({ successMessages, warningMessages, errorMessages, infoMessages, style, onClick }) => {
    return (
        <>
            {infoMessages && infoMessages.length > 0 && (
                <div style={style} className="alert alert-info" role="alert" onClick={onClick}>
                    {Array.isArray(infoMessages) ? (
                        <Messages>
                            {infoMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </Messages>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: infoMessages }}
                        />
                    )}
                </div>
            )}

            {successMessages && successMessages.length > 0 && (
                <div className="alert alert-success" style={style} role="alert" onClick={onClick}>
                    {Array.isArray(successMessages) ? (
                        <Messages>
                            {successMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </Messages>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: successMessages }}
                        />
                    )}
                </div>
            )}

            {warningMessages && warningMessages.length > 0 && (
                <div className="alert alert-warning" style={style} role="alert" onClick={onClick}>
                    {Array.isArray(warningMessages) ? (
                        <Messages>
                            {warningMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </Messages>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: warningMessages }}
                        />
                    )}
                </div>
            )}

            {errorMessages && errorMessages.length > 0 && (
                <div style={style} className="alert alert-danger" role="alert" onClick={onClick}>
                    {Array.isArray(errorMessages) ? (
                        <Messages>
                            {errorMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </Messages>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: errorMessages }}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default AlertComponent;

const Messages = styled.div`
    display: grid;
    row-gap: var(--gap-s);
`;
